import React, { CSSProperties, useState } from 'react';
import Select, { MultiValue } from 'react-select';
import { InputActionMeta } from 'react-select';
import '../SearchableDropdown/SearchableDropdown.scss';

interface OptionType {
    label: string;
    value: string;
}

interface MultiSelectDropdownProps {
    dropdownOptions: OptionType[];
    onInputChange?: (inputValue: string, actionMeta: InputActionMeta) => string;
    onChange?: (value: OptionType) => void;
    value?: OptionType | OptionType[];
    label: string;
    error?: boolean;
    helperText?: string;
}

export const MultiSelectDropdownV3 = ({
  dropdownOptions,
  onInputChange,
  onChange,
  value,
  label,
}: MultiSelectDropdownProps): React.ReactElement => {

  const handleChangeSingle = (newvalue: MultiValue<OptionType>): void => {
    const value = newvalue as unknown as OptionType;
    if (onChange) onChange(value);
  };

  const selectStyles = {
    menu: (base) => ({
      ...base,
      fontSize: 17,
    }),
  };

  const suggestions: OptionType[] =
    dropdownOptions &&
    dropdownOptions.map(it => ({
      value: it && it.value ? it.value : '',
      label: it && it.label ? it.label : '',
    }));

  const customFilter = (value: OptionType, input: string): boolean => {
    return value.label.toLowerCase().includes(input.toLowerCase());
  };

  return (
    <div className="SearchableDropdown">
      <label className={`Searchable-Dropdown-Label`}>{label}</label>
      <div>
        <Select
          isMulti={true}
          styles={selectStyles}
          placeholder=""
          options={suggestions}
          key={`my_unique_select_key__${JSON.stringify(value)}`}
          value={value}
          onChange={handleChangeSingle}
          filterOption={(value, input) =>
            customFilter(value.data as OptionType, input)
          }
        />
      </div>
    </div>
  );
};

export default MultiSelectDropdownV3;
